import { getToken } from "firebase/messaging";
import { messaging } from "../config/firebaseAppConfig";
import { farmvestApi } from "../services/farmvest_api";

// Public VAPID key (safe to include directly in frontend code)
const VAPID_KEY = "BI7QADN3NcxaEeiy8GoSAht_Ua52K8jvLPW66nHgWzMg7BAwkFLxt13Z70hwEwXJGu_XUOji2g18KOEAp13bMGQ";

export const requestNotificationPermission = async () => {
    if (!('Notification' in window)) {
        console.warn('This browser does not support desktop notification');
        return false;
    }

    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            console.log("Notification permission granted. Attempting to get FCM Web Token...");

            // Only try if VAPID_KEY is configured
            if (!VAPID_KEY) {
                console.warn("[FCM] VAPID Key is missing! Please configure REACT_APP_VAPID_KEY in your .env file.");
                return true;
            }

            if (!messaging) return true;
            const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
            if (currentToken) {
                console.log("[FCM] Secure Web Token obtained:", currentToken);
                await registerTokenWithBackend(currentToken);
                return true;
            } else {
                console.warn('[FCM] No registration token available. Request permission to generate one.');
            }
        }
    } catch (err) {
        console.error('[FCM] An error occurred while retrieving token: ', err);
    }

    return false;
};

// Send Token to Python Backend
async function registerTokenWithBackend(token: string) {
    try {
        const sessionRaw = localStorage.getItem('ak_dashboard_session');
        if (!sessionRaw) return;
        const session = JSON.parse(sessionRaw);
        const jwt = session?.access_token || '';
        if (!jwt) return;

        const response = await farmvestApi.post('/api/fcm/register_token', {
            token: token,
            device_type: "web"
        });

        if (response.status !== 200) {
            console.error("[FCM] Backend failed to register token", response.data);
        } else {
            console.log("[FCM] Token successfully registered with Python backend topics!");
        }
    } catch (error) {
        console.error("[FCM] Error hitting config backend:", error);
    }
}

export const showBrowserNotification = async (title: string, options?: NotificationOptions & { onClick?: () => void }) => {
    const hasPermission = await requestNotificationPermission();

    if (hasPermission) {
        try {
            const { onClick, ...restOptions } = options || {};
            const notification = new Notification(title, {
                icon: '/logo192.png',
                badge: '/logo192.png',
                ...restOptions
            });

            notification.onclick = () => {
                window.focus();
                if (onClick) {
                    onClick();
                }
                notification.close();
            };

            return notification;
        } catch (error) {
            console.error('Error showing notification:', error);
        }
    }
};
